import React from 'react';
import { SERIES_COLORS } from '../../../CommonComponents/OPL/charts/charts.constants';
import { GoalTrackDTO } from '../../api/useGoalTrackQuery';
import { ColumnChart } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';

interface Props {
  data: GoalTrackDTO[];
}

export const Chart = ({ data }: Props) => {
  if (data.length === 0) {
    return (
      <Box display="flex" flex={1} px="16">
        <EmptyState />
      </Box>
    );
  }

  const seriesObj = data.reduce(
    (acc, { startValue, trackingValue, endValue, targetValue }) => {
      return {
        ...acc,
        startValue: {
          ...acc.startValue,
          data: [...acc.startValue.data, startValue || 0],
        },
        trackingValue: {
          ...acc.trackingValue,
          data: [...acc.trackingValue.data, trackingValue || 0],
        },
        endValue: {
          ...acc.endValue,
          data: [...acc.endValue.data, endValue || 0],
        },
        targetValue: {
          ...acc.targetValue,
          data: [...acc.targetValue.data, targetValue || 0],
        },
      };
    },
    {
      startValue: {
        name: 'Start Value',
        data: [],
      },
      trackingValue: {
        name: 'Tracking Value',
        data: [],
      },
      endValue: {
        name: 'Current Value',
        data: [],
      },
      targetValue: {
        name: 'Target Value',
        data: [],
        color: SERIES_COLORS[4],
      },
    } as Record<string, { name: string; data: number[] }>,
  );

  const series = Object.values(seriesObj);

  const categories = data.map(({ goalName }) => goalName);

  return (
    <Box maxHeight="400px" width="100%" px="16">
      <ColumnChart series={series} categories={categories} yAxisType="currency" />
    </Box>
  );
};
